import React, { useState } from 'react';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { fetcher } from '@dashboard/services/request';
import { webhooksKey } from '@dashboard/lib/queryKeys';
import Button from '@dashboard/components/Button';
import Card from '@dashboard/components/Card';
import CardHeader from '@dashboard/components/CardHeader';
import CardHeaderTitle from '@dashboard/components/CardHeaderTitle';
import CardContent from '@dashboard/components/CardContent';
import SettingsDescription from '@dashboard/components/SettingsDescription';
import { PlusIcon } from '@heroicons/react/24/outline';
import WebhookTable from './components/WebhookTable';
import WebhookCreateDialog from './components/WebhookCreateDialog';
import Link from '@/dashboard/components/Link';

const SettingsWebhooks = () => {
  const [showCreateWebhookDialog, setShowCreateWebhookDialog] = useState(false);
  const { sellerId, token } = useAuth();

  const {
    data: webhooks,
    isLoading: isLoadingWebhooks,
    isError: isErrorWebhooks,
  } = useQuery({
    queryKey: webhooksKey(sellerId),
    queryFn: () => fetcher(`/sellers/${sellerId}/webhooks`, token),
    enabled: !!sellerId,
  });

  return (
    <Card variant="root">
      <CardHeader variant="root">
        <div className="flex items-start justify-between gap-x-4 w-full">
          <div className="flex flex-col max-w-lg">
            <CardHeaderTitle variant="root">Webhooks</CardHeaderTitle>
            <SettingsDescription className="mt-2">
              Configure webhook endpoints to receive real-time notifications about events.{' '}
              <Link target="_blank" to="/docs/api/v1/webhooks/signature">
                View documentation
              </Link>
            </SettingsDescription>
          </div>
          <Button appearance="primary" onClick={() => setShowCreateWebhookDialog(true)}>
            Create webhook
            <PlusIcon className="w-4 h-4 ml-2 align-baseline" />
          </Button>
        </div>
      </CardHeader>

      <CardContent variant="root" className="mt-4 mb-32">
        <WebhookTable data={webhooks} isLoading={isLoadingWebhooks} isError={isErrorWebhooks} />

        <WebhookCreateDialog
          open={showCreateWebhookDialog}
          onClose={() => setShowCreateWebhookDialog(false)}
        />
      </CardContent>
    </Card>
  );
};

export default SettingsWebhooks;
